"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactHookForm = require("react-hook-form");

var _ramda = require("ramda");

var _classnames = _interopRequireDefault(require("classnames"));

var _yup = require("@hookform/resolvers/yup");

var _TruncatedText = _interopRequireDefault(require("../TruncatedText/TruncatedText"));

var _product = require("./product.schemas");

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      breakpoints = _ref.breakpoints;
  return {
    options: {
      marginTop: spacing(1),
      marginBottom: spacing(2),
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: '24px',
      width: '100%',
      textAlign: 'left'
    },
    fieldHint: {
      marginTop: spacing(1 / 2),
      color: palette.grey.main
    },
    text: {
      wordBreak: 'break-word'
    },
    truncated: {
      maxHeight: 32
    },
    nonTruncated: {
      [breakpoints.down('sm')]: {
        overflowY: 'scroll',
        maxHeight: 100
      }
    },
    buttonWrapper: {
      marginTop: 0,
      marginBottom: 0
    },
    button: {
      fontSize: 12
    }
  };
});

var getFieldName = function getFieldName(item) {
  return "".concat(item.name);
};

var getComboOptions = function getComboOptions(options) {
  return options.reduce(function (acc, item) {
    var name = getFieldName(item);
    acc[name] = '';
    return acc;
  }, {});
};

var getComboOptionsValue = function getComboOptionsValue(selectedOptions) {
  var optionsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var valuesMap = Object.entries(selectedOptions).map(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        optionName = _ref3[0],
        optionValue = _ref3[1];

    var optionsItem = optionsList.find(function (item) {
      return getFieldName(item) === optionName;
    });
    var selectedItem = (optionsItem === null || optionsItem === void 0 ? void 0 : optionsItem.type) === 'text' ? optionValue : ((optionsItem === null || optionsItem === void 0 ? void 0 : optionsItem.options) || []).find(function (item) {
      return item === optionValue;
    });
    return selectedItem !== null && selectedItem !== void 0 ? selectedItem : '';
  });
  return valuesMap.join(', ');
};

var ProductSubmitForm = /*#__PURE__*/(0, _react.forwardRef)(function (_ref4, ref) {
  var _product$optionsList, _product$optionsList2;

  var product = _ref4.product,
      optionsData = _ref4.optionsData,
      _ref4$onSubmit = _ref4.onSubmit,
      onSubmit = _ref4$onSubmit === void 0 ? function () {} : _ref4$onSubmit;
  var classes = useStyles();
  var hasOptions = Boolean(product === null || product === void 0 ? void 0 : (_product$optionsList = product.optionsList) === null || _product$optionsList === void 0 ? void 0 : _product$optionsList.length);
  var isComboOptions = Boolean(product === null || product === void 0 ? void 0 : (_product$optionsList2 = product.optionsList) === null || _product$optionsList2 === void 0 ? void 0 : _product$optionsList2.length);
  var comboFields = (0, _react.useMemo)(function () {
    var _product$optionsList3;

    return getComboOptions((_product$optionsList3 = product === null || product === void 0 ? void 0 : product.optionsList) !== null && _product$optionsList3 !== void 0 ? _product$optionsList3 : []);
  }, [product]);

  var _useForm = (0, _reactHookForm.useForm)({
    mode: 'all',
    defaultValues: comboFields,
    resolver: (0, _yup.yupResolver)((0, _product.buildDynamicValidationSchema)(Object.keys(comboFields)))
  }),
      reset = _useForm.reset,
      handleSubmit = _useForm.handleSubmit,
      control = _useForm.control,
      errors = _useForm.formState.errors;

  var handleSelectProduct = (0, _react.useCallback)(function (data) {
    var options = getComboOptionsValue(data, product === null || product === void 0 ? void 0 : product.optionsList);
    onSubmit(options, data);
  }, [onSubmit, product]);
  var handleSelectProductWithoutOptions = (0, _react.useCallback)(function () {
    return onSubmit('');
  }, [onSubmit]);
  (0, _react.useEffect)(function () {
    if (hasOptions && optionsData && (0, _ramda.difference)((0, _ramda.keys)(optionsData), (0, _ramda.keys)(comboFields)).length === 0) {
      reset(optionsData);
    }
  }, [reset, hasOptions, isComboOptions, optionsData, comboFields]);

  if (!hasOptions) {
    return /*#__PURE__*/_react.default.createElement(_material.Button, {
      disabled: disabledContinue,
      variant: "contained",
      color: "secondary",
      onClick: handleSelectProductWithoutOptions,
      style: {
        minWidth: 160
      }
    }, "Select this gift and continue");
  }

  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit(handleSelectProduct)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.options,
    ref: ref
  }, isComboOptions && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static-Bold"
  }, "Select option(s) for your Direct Delivery:")), ((product === null || product === void 0 ? void 0 : product.optionsList) || []).map(function (item) {
    var name = getFieldName(item);
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      key: item.id,
      mb: 1
    }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
      control: control,
      name: name,
      render: function render(_ref5) {
        var _errors$name;

        var _ref5$field = _ref5.field,
            value = _ref5$field.value,
            onChange = _ref5$field.onChange;
        var commonProps = {
          name,
          value,
          label: item.name,
          fullWidth: true,
          error: !!errors[name],
          helperText: errors[name] && ((_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message)
        };

        if (item.type === 'text') {
          return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, commonProps, {
            variant: "outlined",
            onChange: onChange
          }));
        }

        return /*#__PURE__*/_react.default.createElement(_ui.SelectFilter, (0, _extends2.default)({}, commonProps, {
          dataTestId: "ProductSubmitForm.OptionField.".concat(name),
          renderItems: function renderItems() {
            return (item.options || []).map(function (optionItem) {
              return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
                key: optionItem,
                value: optionItem,
                onClick: function onClick() {
                  onChange(optionItem);
                }
              }, optionItem);
            });
          }
        }));
      }
    }), item.description && /*#__PURE__*/_react.default.createElement(_TruncatedText.default, {
      overrideClasses: classes,
      lines: 1,
      lineHeight: 10
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: (0, _classnames.default)(classes.fieldHint, 'Body-Small-Inactive')
    }, item.description)));
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    px: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    disabled: Object.keys(errors).length > 0,
    fullWidth: true,
    variant: "contained",
    color: "secondary",
    type: "submit"
  }, "Select this gift and continue")));
});

var _default = /*#__PURE__*/(0, _react.memo)(ProductSubmitForm);

exports.default = _default;